import { Formik } from "formik";
import queryString from "query-string";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FormDisplay from "./FormDisplay";
import pages from "../../../constants/pages";
import { useAxios, useAlert } from "../../../hooks";
import { validationSchema, objectFromFormData } from "./brandDetailObject";

export default function Form({
  agencyID,
  list,
  formData,
  editState,
  setEditState,
}) {
  const axios = useAxios();
  const navigate = useNavigate();
  const { alert } = useAlert();
  const dispatch = useDispatch();

  const businessEntityID =
    useSelector((state) => state.memberDetails?.businessEntityID) ||
    sessionStorage.getItem("businessEntityId");

  const multiBrand = queryString.parse(window.location.search).newMultiBrand;
  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={(formData, { setSubmitting }) => {
        let url = "/user/brand";
        let method = "POST";

        if (formData.brandID) {
          url = "/user/brand/" + formData.brandID;
          method = "PUT";
        }

        axios({
          url: url,
          method: method,
          data: objectFromFormData(formData, businessEntityID),
          disableRedirect: true,
        })
          .then((res) => {
            if (res.status) {
              if (!formData.brandID) {
                sessionStorage.setItem("brandID", res.data?.brand_id);
                dispatch(
                  alert({
                    message: "Brand created successfully!",
                    type: "success",
                  })
                );

                if (multiBrand) {
                  navigate(pages.welcomePage.route);
                } else {
                  navigate(pages.createWelcomePage.route);
                }
              }

              if (!!formData.brandID) {
                dispatch(
                  alert({
                    message: "Brand updated successfully!",
                    type: "success",
                  })
                );
                setEditState(false);
              }
            }
            setSubmitting(false);
          })
          .catch((err) => {
            console.error(err);
          });
      }}
    >
      {(formikProps) => (
        <FormDisplay
          agencyID={agencyID}
          multiBrand={multiBrand}
          list={list}
          editState={editState}
          formikProps={formikProps}
          setEditState={setEditState}
        />
      )}
    </Formik>
  );
}
